// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"95":"003b9a1a","453":"d7446e4a","570":"8e34b34f","987":"f064231c"}[chunkId] + ".chunk.js";
};